import React from 'react'
import { Navigate, Outlet, useLocation } from 'react-router-dom'
import { useSelector } from 'react-redux';
import { 
	AUTH_PREFIX_PATH, 
	UNAUTHENTICATED_ENTRY, 
	REDIRECT_URL_KEY,
	APP_PREFIX_PATH
} from 'configs/AppConfig'

const ProtectedRoute = () => {
	
	const { token, driverid } = useSelector(state => state.auth)
	const location = useLocation()

	if (!token) {
		return <Navigate to={`${AUTH_PREFIX_PATH}${UNAUTHENTICATED_ENTRY}?${REDIRECT_URL_KEY}=${location.pathname}`} replace />;
	}

	if (location.pathname === '/' || location.pathname === APP_PREFIX_PATH) {
		if (driverid) {
			return <Navigate to={`${APP_PREFIX_PATH}/parent/driver`} replace />;
		} else {
			return <Navigate to={`${APP_PREFIX_PATH}/parent/dashboard`} replace />;
		}
	}

	return <Outlet />
}

export default ProtectedRoute